// Country codes for the phone field: Bolivia first (the default), then alphabetical
const byName = (a, b) => a.name.localeCompare(b.name, 'es');

const OTHERS = [
  ['DE', 'Alemania', '49'],
  ['AR', 'Argentina', '54'],
  ['AU', 'Australia', '61'],
  ['AT', 'Austria', '43'],
  ['BE', 'Bélgica', '32'],
  ['BR', 'Brasil', '55'],
  ['CA', 'Canadá', '1'],
  ['CL', 'Chile', '56'],
  ['CN', 'China', '86'],
  ['CO', 'Colombia', '57'],
  ['KR', 'Corea del Sur', '82'],
  ['CR', 'Costa Rica', '506'],
  ['CU', 'Cuba', '53'],
  ['DK', 'Dinamarca', '45'],
  ['EC', 'Ecuador', '593'],
  ['SV', 'El Salvador', '503'],
  ['ES', 'España', '34'],
  ['US', 'Estados Unidos', '1'],
  ['FR', 'Francia', '33'],
  ['GT', 'Guatemala', '502'],
  ['HN', 'Honduras', '504'],
  ['IN', 'India', '91'],
  ['IE', 'Irlanda', '353'],
  ['IL', 'Israel', '972'],
  ['IT', 'Italia', '39'],
  ['JP', 'Japón', '81'],
  ['MX', 'México', '52'],
  ['NI', 'Nicaragua', '505'],
  ['NO', 'Noruega', '47'],
  ['NZ', 'Nueva Zelanda', '64'],
  ['NL', 'Países Bajos', '31'],
  ['PA', 'Panamá', '507'],
  ['PY', 'Paraguay', '595'],
  ['PE', 'Perú', '51'],
  ['PL', 'Polonia', '48'],
  ['PT', 'Portugal', '351'],
  ['PR', 'Puerto Rico', '1'],
  ['GB', 'Reino Unido', '44'],
  ['DO', 'República Dominicana', '1'],
  ['RU', 'Rusia', '7'],
  ['ZA', 'Sudáfrica', '27'],
  ['SE', 'Suecia', '46'],
  ['CH', 'Suiza', '41'],
  ['TR', 'Turquía', '90'],
  ['UY', 'Uruguay', '598'],
  ['VE', 'Venezuela', '58'],
].map(([iso, name, code]) => ({ iso, name, code }));

export const COUNTRIES = [{ iso: 'BO', name: 'Bolivia', code: '591' }, ...OTHERS.sort(byName)];

export const DEFAULT_COUNTRY = 'BO';

// Countries missing from the list type their code by hand
export const OTHER_COUNTRY = 'OTHER';

// Regional indicator letters render as the country's flag emoji
export const flag = (iso) => String.fromCodePoint(...[...iso].map((ch) => 0x1f1a5 + ch.charCodeAt(0)));
